import { render, staticRenderFns } from "./editSpec.vue?vue&type=template&id=54938c20&scoped=true"
import script from "./editSpec.vue?vue&type=script&lang=js"
export * from "./editSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54938c20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54938c20')) {
      api.createRecord('54938c20', component.options)
    } else {
      api.reload('54938c20', component.options)
    }
    module.hot.accept("./editSpec.vue?vue&type=template&id=54938c20&scoped=true", function () {
      api.rerender('54938c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/specialty/editSpec.vue"
export default component.exports